import { Action } from 'redux';

import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Progress broadcast

export interface ForumFeedCommentedFetchAction extends Action {
    readonly after: number; // Last item id
}

export const FEED_COMMENTED_FETCH_REQUEST = 'FEED_COMMENTED_FETCH_REQUEST';
export interface FeedCommentedFetchRequestAction extends ForumFeedCommentedFetchAction, APIRequestAction {
    readonly type: typeof FEED_COMMENTED_FETCH_REQUEST;
}
export interface FeedCommentedFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { posts: number[]; };
}
export const FEED_COMMENTED_FETCH_SUCCESS = 'FEED_COMMENTED_FETCH_SUCCESS';
export interface FeedCommentedFetchSuccessAction extends ForumFeedCommentedFetchAction, APISuccessAction<FeedCommentedFetchNormalizedResponse> {
    readonly type: typeof FEED_COMMENTED_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
    readonly notificationsOn: number[];
}

export const FEED_COMMENTED_FETCH_FAILURE = 'FEED_COMMENTED_FETCH_FAILURE';
export interface FeedCommentedFetchFailureAction extends ForumFeedCommentedFetchAction, APIFailureAction {
    readonly type: typeof FEED_COMMENTED_FETCH_FAILURE;
}

export const feedCommentedFetch = {
    request: (after: number): FeedCommentedFetchRequestAction => ({ type: FEED_COMMENTED_FETCH_REQUEST, after }),
    success: (after: number, hasNext: number, hasPrevious: number, notificationsOn: number[], response: FeedCommentedFetchNormalizedResponse):
        FeedCommentedFetchSuccessAction => ({
        type: FEED_COMMENTED_FETCH_SUCCESS, after, hasNext, hasPrevious, notificationsOn, response,
    }),
    failure: (after: number, error: any): FeedCommentedFetchFailureAction => ({ type: FEED_COMMENTED_FETCH_FAILURE, after, error }),
};

// Feed Commented load
export const FEED_COMMENTED_LOAD = 'FEED_COMMENTED_LOAD';
export interface FeedCommentedLoadAction extends ForumFeedCommentedFetchAction {
    readonly type: typeof FEED_COMMENTED_LOAD;
    readonly username: string;
    readonly after: number; // Timestamp of the last post in the list - for infinity scroll
}
export const feedCommentedLoad = (username: string, after?: number): FeedCommentedLoadAction => ({
    type: FEED_COMMENTED_LOAD, username, after,
});
